import { BubbleColor, Bubble } from 'js/bubbleCore/bubbles/types';

const colorMap: {[key in BubbleColor]: number} = {
  [BubbleColor.A]: 0x1c94ea,
  [BubbleColor.B]: 0x3ae21c,
  [BubbleColor.C]: 0xdc3fc5,
  [BubbleColor.D]: 0xfc401b,
  [BubbleColor.E]: 0x20e7e6,
  [BubbleColor.F]: 0xfdf14b,
  [BubbleColor.NONE]: 0xffffff,
}

export function getColorForBubble(bubble: Bubble): number {
  return colorMap[bubble.core.color];
}